module.exports = __webpack_public_path__ + "img/trandape@2x.8d27bdff.png";